import {Box} from '@mantine/core';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import {MODEL_HUB_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import navigateToURL from 'lib/navigateToURL';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import usePreference from 'ui-library/hooks/usePreference';

const MODEL_HUB_PROMO_PREFERENCE_KEY = 'model-hub-banner-dismissed';

/**
 * Promotional banner shown on the 3D Structure tab encouraging users to try
 * the Model Hub for bulk structure predictions. Dismissible per-user.
 */
export default function ModelHubBulkBanner(): JSX.Element | null {
  const [dismissed, setDismissed] = usePreference<boolean | undefined>(MODEL_HUB_PROMO_PREFERENCE_KEY);

  if (!BenchlingConfig.MODEL_HUB_ENABLE_MODEL_HUB_UI || dismissed) {
    return null;
  }

  return (
    <Box m="xs">
      <InlineBanner
        bannerType={InlineBannerType.ATTENTION}
        text="Want to run predictions in bulk?"
        dataTestAttrs={{component: 'ModelHubBulkBanner', element: 'root'}}
        action={{
          actionType: InlineBannerActionType.CUSTOM,
          actionText: 'Check out the new Model Hub',
          actionOnClick: () => {
            trackEvent(MODEL_HUB_ANALYTICS_ACTIONS.STRUCTURE_TAB_BANNER_CLICKED);
            navigateToURL('/model-hub');
          },
        }}
        onDismiss={() => {
          setDismissed(true);
        }}
      />
    </Box>
  );
}
